import Snappy from '../libs/snappy/snappy';

import '../styles/eduhub-main.scss';

import objectFitVideos from 'object-fit-videos';

objectFitVideos();

window.$ = window.jQuery = require('jquery');

require('../components/edu-filters/scripts/edu-filters');
require('../components/edu-feedback/scripts/edu-feedback');
require('../components/edu-intro-tour/scripts/edu-intro-tour');
require('../components/edu-sticky/scripts/edu-sticky');
require('../components/edu-post-login-drd/scripts/edu-post-login-drd');
require('../components/edu-profile-privacy-toggler/scripts/edu-profile-privacy-toggler');
require('../components/edu-course-loader/scripts/edu-course-loader');
require('../components/edu-unsaved-data-observer/scripts/edu-unsaved-data-observer');
require('../components/revealEffect/scripts/revealEffect');
require('../components/copy-to-clipboard/scripts/copy-to-clipboard');
require('../components/scroll-progress/scripts/scroll-progress');
require('../components/session-hero/scripts/session-hero');
require('../components/grid-placeholder/scripts/grid-placeholder');
require('../components/playlist-nav/scripts/playlist-nav');
require('../components/modal-video/scripts/modal-video');
require('../components/comments/scripts/comments');
require('../components/tooltip/scripts/tooltip');
require('../components/mouseover-arrow/scripts/mouseover-arrow');
require('../components/scroll-tracking/scripts/scroll-tracking');
require('../components/login-prompt-initiator/scripts/login-prompt-initiator');
require('../components/bursary-form/scripts/bursary-form');
require('../components/comments-count/scripts/comments-count');
require('../components/ir-trigger/scripts/ir-trigger');
require('../components/edu-alert/scripts/edu-alert');
require('../components/edu-disclaimer/scripts/edu-disclaimer');
require('../components/approach-pointer/scripts/approach-pointer');
require('../components/edu-section-updater/scripts/edu-section-updater');
require('../components/edu-sitenavigation/scripts/edu-sitenavigation');


Snappy.init();



// WEBPACK FOOTER //
// ./scripts/eduhub-index.js